import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  IconButton,
  Button,
  Chip,
  Divider,
  Alert,
} from "@mui/material";
import {
  CheckCircle,
  Cancel,
  VpnKey,
  PersonAdd,
  History,
  Info,
  WhatsApp,
} from "@mui/icons-material";
import { toast } from "react-toastify";

const ApprovalCenter = () => {
  // Mock requests - will be replaced by API calls to the requests table
  const [requests, setRequests] = useState([
    {
      id: "req-1",
      type: "password_reset",
      user: "Chandan Allam",
      email: "chandan.71947@gmail.com",
      timestamp: new Date(),
      status: "pending",
      description: "Request to reset Master Admin password",
      phone: "9876543210"
    },
    {
      id: "req-2",
      type: "leave_request",
      user: "Amit Kumar",
      email: "amit@student.com",
      timestamp: new Date(Date.now() - 7200000),
      status: "pending",
      description: "Home visit request (April 15 - April 20)"
    },
    {
      id: "req-3",
      type: "room_swap",
      user: "Kiran S.",
      email: "kiran@student.com",
      timestamp: new Date(Date.now() - 14400000),
      status: "pending",
      description: "Requesting move from Room 102 to Room 205 (medical reasons)"
    },
    {
      id: "req-4",
      type: "vacate_request",
      user: "Suresh P.",
      email: "suresh@student.com",
      timestamp: new Date(Date.now() - 86400000),
      status: "pending",
      description: "Intent to vacate by end of the month (April 30)"
    }
  ]);

  const handleAction = (id, action) => {
    setRequests(requests.filter(req => req.id !== id));
    toast.success(`Request ${action === 'approve' ? 'Approved' : 'Rejected'} successfully.`);
  };

  const getIcon = (type) => {
    switch (type) {
      case "password_reset": return <VpnKey color="warning" />;
      case "new_warden": return <PersonAdd color="info" />;
      case "leave_request": return <History color="primary" />;
      case "room_swap": return <History color="secondary" />;
      case "vacate_request": return <Cancel color="error" />;
      default: return <Info />;
    }
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Global Approval Center
      </Typography>
      <Typography variant="body1" color="text.secondary" mb={4}>
        Review and authorize sensitive security and personnel requests.
      </Typography>

      <Paper sx={{ p: 2, borderRadius: 3 }}>
        <Box display="flex" justifyContent="space-between" p={2}>
          <Typography variant="h6">Pending Queue ({requests.length})</Typography>
          <Button startIcon={<History />} variant="text" size="small">View History</Button>
        </Box>
        <Divider />
        
        {requests.length === 0 ? (
          <Box textAlign="center" py={8}>
            <CheckCircle sx={{ fontSize: 64, color: "success.light", opacity: 0.5, mb: 2 }} />
            <Typography variant="h6" color="text.secondary">All Caught Up!</Typography>
            <Typography variant="body2" color="text.secondary">No pending requests require your approval.</Typography>
          </Box>
        ) : (
          <List>
            {requests.map((req, index) => (
              <React.Fragment key={req.id}>
                <ListItem sx={{ py: 2 }}>
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: "background.default", border: "1px solid rgba(255,255,255,0.1)" }}>
                      {getIcon(req.type)}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText 
                    primary={
                      <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="subtitle1" fontWeight="bold">{req.user}</Typography>
                        <Chip label={req.type.replace('_', ' ').toUpperCase()} size="small" variant="outlined" sx={{ fontSize: '0.6rem' }} />
                      </Box>
                    }
                    secondary={
                      <Box>
                        <Typography variant="body2" color="text.secondary">{req.description}</Typography>
                        <Typography variant="caption" color="text.disabled">{req.timestamp.toLocaleString()}</Typography>
                      </Box>
                    }
                  />
                  <Box display="flex" gap={1}>
                    {req.phone && (
                        <IconButton 
                          onClick={() => window.open(`https://wa.me/91${req.phone.replace(/[^0-9]/g, '')}`, '_blank')} 
                          title="Contact via WhatsApp"
                        >
                          <WhatsApp sx={{ color: '#25D366' }} />
                        </IconButton>
                    )}
                    <IconButton color="error" onClick={() => handleAction(req.id, 'reject')} title="Reject Request">
                      <Cancel />
                    </IconButton>
                    <IconButton color="success" onClick={() => handleAction(req.id, 'approve')} title="Authorize Request">
                      <CheckCircle />
                    </IconButton>
                  </Box>
                </ListItem>
                {index < requests.length - 1 && <Divider component="li" />}
              </React.Fragment>
            ))}
          </List>
        )}
      </Paper>

      <Alert severity="info" sx={{ mt: 3, borderRadius: 2 }}>
        <strong>Security Tip:</strong> Always verify identity before authorizing password resets or new staff registrations.
      </Alert>
    </Box>
  );
};

export default ApprovalCenter;
